import { render, staticRenderFns } from "./HeatCAD.vue?vue&type=template&id=19948a13&scoped=true"
import script from "./HeatCAD.vue?vue&type=script&lang=js"
export * from "./HeatCAD.vue?vue&type=script&lang=js"
import style0 from "./HeatCAD.vue?vue&type=style&index=0&id=19948a13&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19948a13",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QIcon,QCard,QCardSection,QSeparator});
